import { createApp } from 'vue';
import App from './App.vue';
import './style.css';

if (import.meta.env.DEV && location.pathname.endsWith('/test-access')) {
  const { default: TestAccess } = await import('./TestAccess.vue');
  createApp(TestAccess).mount('#mandatary-app');
} else if (import.meta.env.DEV && location.pathname.endsWith('/test-location-picker')) {
  const { default: TestLocationPicker } = await import('./TestLocationPicker.vue');
  createApp(TestLocationPicker).mount('#mandatary-app');
} else {
  createApp(App).mount('#mandatary-app');
}
